$(document).ready(function () {
    const $accordion = $("#product-information-accordion");
    if ($accordion.length === 0) return;

    const $panels = $accordion.find(".accordion-collapse");

    const setExpanded = function (panel, expanded) {
        const $panel = $(panel);
        $panel.toggleClass("show", expanded);
        $accordion
            .find('[data-bs-target="#' + $panel.attr("id") + '"]')
            .toggleClass("collapsed", !expanded)
            .attr("aria-expanded", expanded ? "true" : "false");
    };

    $accordion.find(".accordion-button").on("click", function (event) {
        if (!$.mediaQuery("lg")) return;
        if ($(this).hasClass("collapsed")) return;

        event.preventDefault();
        event.stopPropagation();
    });

    let wasDesktop = null;

    const sync = function () {
        const isDesktop = $.mediaQuery("lg");
        if (isDesktop === wasDesktop) return;
        wasDesktop = isDesktop;

        if (isDesktop) {
            if ($panels.filter(".show").length === 0)
                setExpanded($panels.get(0), true);
        } else {
            $panels.each(function () {
                setExpanded(this, false);
            });
        }
    };

    sync();
    $(window).on("resize", sync);
});
